import { Box, CircularProgress } from "@mui/material";

const Loader = (props: any) => {
  if (!props.isLoad) return null;
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255,255,255,0.3)',
        zIndex: 10,
      }}
    >
      <CircularProgress style={{ color: '#e71c57' }} thickness={3} size={48} />
    </Box>
  );
};

export default Loader;
